import React, { type CSSProperties, type ReactNode } from 'react';

import {
  TooltipContent,
  TooltipProvider,
  Tooltip as RadixTooltip,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type TooltipProps = {
  children: ReactNode;
  content: ReactNode;
  style?: CSSProperties;
  placement?: string;
  triggerProps?: {
    isDisabled?: boolean;
    delay?: number;
  };
};

function parseSide(placement?: string): 'top' | 'bottom' | 'left' | 'right' {
  const first = (placement ?? 'top').split(' ')[0];
  if (first === 'left' || first === 'right' || first === 'bottom') return first;
  return 'top';
}

function parseAlign(placement?: string): 'start' | 'center' | 'end' {
  const second = (placement ?? '').split(' ')[1];
  if (second === 'start' || second === 'top') return 'start';
  if (second === 'end' || second === 'bottom') return 'end';
  return 'center';
}

export const Tooltip = ({
  children,
  content,
  style,
  placement,
  triggerProps = {},
}: TooltipProps) => {
  if (triggerProps.isDisabled) {
    return <>{children}</>;
  }

  return (
    <TooltipProvider delayDuration={triggerProps.delay ?? 300}>
      <RadixTooltip>
        <TooltipTrigger asChild>
          <span style={{ display: 'contents' }}>{children}</span>
        </TooltipTrigger>
        <TooltipContent
          side={parseSide(placement)}
          align={parseAlign(placement)}
          style={style}
        >
          {content}
        </TooltipContent>
      </RadixTooltip>
    </TooltipProvider>
  );
};
